import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit, isSubmitting, isDirty, getFormValues } from 'redux-form';

import objectDiff from 'utils/objectDiff';

import Button from 'components/common/Button';
import InventoryCategoryCreateEditForm from './InventoryCategoryCreateEditForm';

const styles = theme => ({
  form: {
    overflow: 'hidden',
    padding: '25px 90px 40px',
    [theme.breakpoints.down('sm')]: {
      padding: '25px 0 40px',
    },
  },
});

const InventoryCategoryCreateEditDialog = ({
  open,
  onClose,
  ID,
  onSubmitSuccess,
  form,
  formValues,
  initialValues,
  actions,
  dirty,
  submitting,
  classes,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        {ID ? 'Edit Product Category' : 'New Product Category'}
      </Typography>
    </DialogTitle>
    <DialogContent withScrollbars>
      <InventoryCategoryCreateEditForm
        className={classes.form}
        onSubmitSuccess={onSubmitSuccess}
        form={form}
        {...ID ? { ID } : {}}
        {...initialValues ? { initialValues } : {}}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => {
          if (ID) {
            if (Object.keys(objectDiff(formValues, initialValues)).length > 0) {
              actions.submit(form);
            } else {
              onClose();
            }
          } else if (dirty) {
            actions.submit(form);
          } else {
            onClose();
          }
        }}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        Done
      </Button>
    </DialogActions>
  </Dialog>
);

InventoryCategoryCreateEditDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  form: PropTypes.string,
  ID: PropTypes.number,
  initialValues: PropTypes.shape({
    Name: PropTypes.string,
  }),
  submitting: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  formValues: PropTypes.shape({
    Name: PropTypes.string,
  }),
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

InventoryCategoryCreateEditDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onSubmitSuccess: () => {},
  form: 'inventoryCategoryCreate',
  initialValues: null,
  ID: null,
  formValues: null,
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(ownProps.form)(store),
  dirty: isDirty(ownProps.form)(store),
  formValues: getFormValues(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});


export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(InventoryCategoryCreateEditDialog),
);



// WEBPACK FOOTER //
// ./src/components/settings/InventoryCategoryCreateEditDialog/InventoryCategoryCreateEditDialog.js